import React, { useEffect } from 'react'
import { useIntl, navigate } from 'gatsby-plugin-intl'
import Layout from '../../components/Layout/index'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import SEO from '../../components/seo'
import PressRelease from '../../components/PressRelease'

import messages from '../../messages/pageTitles.lang'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import Image from '../../images/news/news_universal_teaser.png'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  useEffect(() => {
    if (global.window && locale === 'en') {
      navigate('/newsroom/')
    }
  }, [])

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsUniversal)}
        imageAlt={formatMessage(messages.TitleNewsUniversal)}
        description={formatMessage(metaDescription.NewsUniversalDescription)}
        nofollow={locale === 'en'}
        image={Image}
        lang={locale}
      />
      <PressRelease article={newsList.universal} />
    </Layout>
  )
}

export default IndexPage
